"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGuidedSellingStatus = void 0;
var _uiSelectors = require("../../store/ui/uiSelectors");
var uiActions = _interopRequireWildcard(require("../../store/ui/uiActions"));
var _services = require("../../services");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
var _useConfig = _interopRequireDefault(require("../useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useGuidedSellingStatus = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const isGuidedSellingModalOpen = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectIsGuidedSellingModalOpen);
  const isFloaterOpen = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectIsFloaterOpen);
  //This is here because on the Dialog component from MUI handles overflow by itself and us setting it makes it buggy
  const enableShadowDOM = (0, _useConfig.default)('enableShadowDOM', false);
  //------------------------------------------------------------------------------------------------------------------
  const body = document.querySelector('body');
  const openGuidedSellingModal = () => {
    if (isGuidedSellingModalOpen) {
      return;
    }
    dispatch(uiActions.openGuidedSellingModal());
    _services.analytics.startJourney();

    //remove scrollbar from page when modal opened
    if (!enableShadowDOM) {
      body.style.overflow = 'hidden';
    }
  };
  const closeGuidedSellingModal = () => {
    dispatch(uiActions.closeGuidedSellingModal());

    //restore the default behavior of scrollbar of the body when modal closed
    if (!enableShadowDOM) {
      body.style.overflow = '';
    }
  };
  const openFloater = () => {
    dispatch(uiActions.openFloater());
  };
  const closeFloater = closedBy => {
    dispatch(uiActions.closeFloater(closedBy));
  };
  return {
    isGuidedSellingModalOpen,
    isFloaterOpen,
    openGuidedSellingModal,
    closeGuidedSellingModal,
    openFloater,
    closeFloater
  };
};
exports.useGuidedSellingStatus = useGuidedSellingStatus;